import { onMounted, ref, watch, nextTick } from 'vue'
import { useDialogMessage } from '../../messages/useDialogMessage'
import { useGlobalState } from '../useGlobalState'

export function useDialog(id: string, initOpen = false) {
  const opened = ref(initOpen)
  const message = useDialogMessage(id)
  const globalState = useGlobalState()

  function open() {
    opened.value = false
    nextTick(() => {
      opened.value = true
      globalState.updateDialog(id, true)
    })
  }

  function close() {
    opened.value = false
    globalState.updateDialog(id, false)
  }

  function onDialogOpened(handle: Function) {
    watch(opened, () => {
      if (opened.value) handle()
    })
  }

  function onDialogClosed(handle: Function) {
    watch(opened, () => {
      if (!opened.value) handle()
    })
  }

  message.onOpenDialogCommand((payload: any) => {
    if (payload.id == id || payload.id == '*') {
      open()
    }
  })

  message.onCloseDialogCommand((payload: any) => {
    if (payload.id == id || payload.id == '*') {
      if (opened.value) {
        close()
      }
    }
  })

  return {
    opened,
    open,
    close,
    onDialogOpened,
    onDialogClosed,
  }
}
